import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "w-full mt-4 overflow-y-auto overflow-x-hidden",
  style: {"grid-area":"table"}
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"hidden md:grid lg:grid-cols-12 md:grid-cols-8 gap-2 w-full items-center text-left py-2 border-b font-semibold text-gray-700 text-xs md:text-sm\"><div class=\"md:col-span-1\">ID</div><div class=\"md:col-span-3\">Nome</div><div class=\"md:col-span-2\">Início</div><div class=\"md:col-span-2\">Final</div><div class=\"md:col-span-2\">Responsável</div><div class=\"md:col-span-2\">Data do vínculo</div></div>", 1)

import { computed, ref } from 'vue'
import TableDomainDsPolicy from '@/components/designSystem/Table/TableDomainDsPolicies.vue'
import EmptyList from '@/components/EmptyList.vue'
import { MappedDomainPolicy } from '@/types/domain'


export default /*#__PURE__*/_defineComponent({
  __name: 'domain.tab',
  props: {
    policies: {}
  },
  setup(__props: any) {

const props = __props;



const currentPage = ref(1)
const itemsPerPage = ref(5)

const paginatedPolicies = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value
  return props.policies.slice(start, start + itemsPerPage.value)
})

const pageCount = computed(() => Math.ceil(props.policies.length / itemsPerPage.value))

const changePage = (page: number) => {
  currentPage.value = page
}

return (_ctx: any,_cache: any) => {
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (paginatedPolicies.value.length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_2,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedPolicies.value, (policy) => {
              return (_openBlock(), _createBlock(TableDomainDsPolicy, {
                key: policy.id,
                data: policy
              }, null, 8, ["data"]))
            }), 128))
          ], 64))
        : (_openBlock(), _createBlock(EmptyList, {
            key: 1,
            title: "Nenhuma política encontrada"
          }))
    ]),
    (paginatedPolicies.value.length > 0)
      ? (_openBlock(), _createBlock(_component_v_pagination, {
          key: 0,
          modelValue: currentPage.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
            changePage
          ],
          "total-visible": 5,
          "per-page": itemsPerPage.value,
          length: pageCount.value,
          density: "comfortable",
          color: "primary"
        }, null, 8, ["modelValue", "per-page", "length"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})